module.exports = __webpack_public_path__ + "static/media/08-colorRedImg.aa7d9eff.png";